import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['addressForm']
  static values = {
    rerenderFormPath: String,
  }

  addressFormTargetConnected(element) {
    $(element).enableClientSideValidations()
  }

  rerenderForm(event) {
    const formData = new FormData(this.form)

    post(this.rerenderFormPathValue, {
      body: formData,
      responseKind: 'turbo-stream',
    })
  }

  get form() {
    return this.addressFormTarget
  }
}
